@let _keys = keys();

<header class="dialog-header">
	<div></div>
	<button [attr.aria-label]="'close' | translate" [attr.title]="'close' | translate" class="action" (click)="cancel()">
		<i class="ico ico-close"></i>
	</button>
</header>

<div class="activator-execution-result content">
	<h1 class="title">{{ _keys.executionResult.title }}</h1>
	<ul class="list dense">
		<li class="list-item">
			<div class="label">
				<div class="text">
					<h4 translate="process.enactment.activator.execution.status"></h4>
					<div class="icon-and-text">
						@if (_keys.executionResult.status === "warnings") {
							<i class="ico ico-warning warning-color"></i>
						}
						@if (_keys.executionResult.status === "failure") {
							<i class="ico ico-warning error-color"></i>
						}
						@if (_keys.executionResult.status === "success") {
							<i class="ico ico-check success-color"></i>
						}
						<p [translate]="getStatusMessageKey()"></p>
					</div>
				</div>
			</div>
		</li>
		<li class="list-item">
			<div class="label">
				<div class="text">
					<h4 translate="process.enactment.activator.execution.activator"></h4>
					<p>{{ _keys.executionResult.activatorName }}</p>
				</div>
			</div>
		</li>
		@if (_keys.executionResult.executionDate) {
			<li class="list-item">
				<div class="label">
					<div class="text">
						<h4 translate="process.enactment.activator.execution.date"></h4>
						<p>{{ _keys.executionResult.executionDate }}</p>
					</div>
				</div>
			</li>
		}
		<li class="list-item">
			<div class="label">
				<div class="text">
					<h4 translate="process.enactment.activator.execution.user"></h4>
					<p>{{ _keys.executionResult.userFullname }}</p>
				</div>
			</div>
		</li>
		@if (_keys.executionResult.summary) {
			<li class="list-item">
				<div class="label">
					<div class="text">
						<h4 translate="process.enactment.activator.execution.summary"></h4>
						@if (_keys.executionResult.summary.messageKey && !_keys.executionResult.summary.url) {
							<p [translate]="_keys.executionResult.summary.messageKey"></p>
						}
						@if (!_keys.executionResult.summary.messageKey && !_keys.executionResult.summary.url) {
							<p>
								{{ _keys.executionResult.summary.message }}
							</p>
						}
						@if (_keys.executionResult.summary.messageKey && _keys.executionResult.summary.url) {
							<a [href]="_keys.executionResult.summary.url" target="_blank">{{
								_keys.executionResult.summary.messageKey | translate
							}}</a>
						}
						@if (!_keys.executionResult.summary.messageKey && _keys.executionResult.summary.url) {
							<a [href]="_keys.executionResult.summary.url" target="_blank">{{
								_keys.executionResult.summary.message
							}}</a>
						}
					</div>
				</div>
			</li>
		}
		@if (_keys.executionResult.partialResults.length > 0) {
			<li class="list-item">
				<div class="label">
					<div class="text">
						<h4 translate="process.enactment.activator.execution.partialresults"></h4>
						<ul class="list sublist dense">
							@for (partialResult of _keys.executionResult.partialResults; track partialResult) {
								<li class="list-item sublist-item">
									@if (partialResult.status === "warnings") {
										<i class="ico ico-warning warning-color"></i>
									}
									@if (partialResult.status === "failure") {
										<i class="ico ico-warning error-color"></i>
									}
									@if (partialResult.status === "success") {
										<i class="ico ico-check success-color"></i>
									}
									@if (partialResult.messageKey && !partialResult.url) {
										<p translate="partialResult.messageKey"></p>
									}
									@if (!partialResult.messageKey && !partialResult.url) {
										<p>{{ partialResult.message }}</p>
									}
									@if (partialResult.messageKey && partialResult.url) {
										<a [href]="partialResult.url" target="_blank">{{ partialResult.messageKey | translate }}</a>
									}
									@if (!partialResult.messageKey && partialResult.url) {
										<a [href]="partialResult.url" target="_blank">{{ partialResult.message }}</a>
									}
								</li>
							}
						</ul>
					</div>
				</div>
			</li>
		}
	</ul>
</div>

<footer>
	<div class="buttons-bottom buttons-right buttons-bottom-margin-fix">
		<div class="spacer"></div>
		<button class="button sm ok" translate="ok" (click)="cancel()" tabindex="1"></button>
	</div>
</footer>
